module.exports = {
    /**
     * Функция преобразование Error в нормальный объект, который можно засунуть в JSON.stringify()
     * Если этого не сделать, то JSON.stringify преобразует Error в пустую строку
     * @param value
     * @returns {*}
     */
    convert (value) {
        if (value instanceof Error) {
            let error = {};

            Object.getOwnPropertyNames(value).forEach(function (key) {
                error[key] = value[key];
            });

            return error;
        }

        return value;
    }
};



// WEBPACK FOOTER //
// ./helpers/errorToObjectConverter.js